import React from "react";
import { Form, Offcanvas, Spinner, Table } from "react-bootstrap";

const TableProperties = ({
  Show,
  Hide,
  Title,
  tableRef,
  onMouseDown,
  updateTableProperties,
  buttonLoader,
  formColumn,
  tableColumns,
  setTableColumns,
}) => {
  const handleCheckboxChange = (checked, column) => {
    setTableColumns((prev) => {
      const updated = { ...prev };
      if (checked) {
        updated[column.columnName] = true;
      } else {
        delete updated[column.columnName];
      }
      return updated;
    });
  };

  const handleSelectAllChange = (checked) => {
    if (checked) {
      const newSelected = {};
      formColumn.forEach((col) => {
        newSelected[col.columnName] = true;
      });
      setTableColumns(newSelected);
    } else {
      setTableColumns({});
    }
  };

  const isChecked = (columnName) => !tableColumns[columnName];
  const allSelected =
    formColumn.length > 0 &&
    formColumn.every((col) => !tableColumns[col.columnName]);

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {Title} <span className="fs-10">-[Check for hide]</span>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <Table ref={tableRef} className="m-0 custom-table" hover striped>
            <thead className="position-sticky top-0">
              <tr>
                <th
                  onMouseDown={(e) => onMouseDown(e, 0)}
                  style={{ width: 45 }}
                  className="text-center"
                >
                  <Form.Check
                    type="checkbox"
                    checked={allSelected}
                    onChange={(e) =>
                      handleSelectAllChange(allSelected ? true : false)
                    }
                  />
                </th>
                <th onMouseDown={(e) => onMouseDown(e, 1)}>Column Label</th>
                <th onMouseDown={(e) => onMouseDown(e, 2)}>Column Name</th>
                <th
                  style={{ width: 100 }}
                  onMouseDown={(e) => onMouseDown(e, 3)}
                >
                  Column Type
                </th>
              </tr>
            </thead>
            <tbody>
              {formColumn?.map((item, index) => (
                <tr key={`dynamic-${index}`}>
                  <td className="text-center">
                    <Form.Check
                      type="checkbox"
                      checked={isChecked(item.columnName)}
                      onChange={(e) =>
                        handleCheckboxChange(
                          isChecked(item.columnName) ? true : false,
                          item
                        )
                      }
                    />
                  </td>
                  <td>{item?.columnLabel}</td>
                  <td>{item?.columnName}</td>
                  <td>{item?.columnType}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Offcanvas.Body>
        <div className="border-top text-end p-2">
          <button
            onClick={() => updateTableProperties()}
            className="updateProfile"
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Applying...
              </div>
            ) : (
              "Apply"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default TableProperties;
